import React, { useEffect, useRef, useState } from 'react';

const Taskbar = ({ startMenuOpen, setStartMenuOpen }) => {
    const [dateTime, setDateTime] = useState({ date: '', time: '' });
    const [isMobile, setIsMobile] = useState(window.innerWidth < 630);
    const startButtonRef = useRef(null);

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();

            const date = now.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            const time = now.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZoneName: 'short'
            });

            setDateTime({ date, time });
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 630);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                startButtonRef.current &&
                !startButtonRef.current.contains(event.target)
            ) {
                setStartMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [setStartMenuOpen]);

    return (
        <div className='Taskbar'>
            <button
                ref={startButtonRef}
                className='StartButton'
                onClick={(e) => {
                    e.stopPropagation(); // prevent immediate closing
                    setStartMenuOpen(!startMenuOpen);
                }}
            >
                <img
                    src={isMobile ? '/images/MainLogo.png' : '/images/MainLogo.png'}
                    alt='Start Logo'
                />
                START
            </button>
            <div className='TaskbarInfo'>
                <span className='localdate'>{dateTime.date}</span>
                <span className='localtime'>{dateTime.time}</span>
            </div>
        </div>
    );
};

export default Taskbar;
